import routerOptions0 from "/var/lib/jenkins/workspace/oh0t/landry/portal/src_bfd5ad77/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}